import React, { useEffect, useRef, useState } from "react"
import { isJson } from "../../core/utils/jsonVerify"
import { Card } from "../../components/Card"
import { HeaderCardESM } from "../../components/Header"
import { EsmSpeedometerProducer } from "../../components/EsmSpeedometerProducer"
import { Grid } from "../../components/Table"
import { ModalBody, ModalHeader, ModalPanel } from "../../components/Modal"
import { BadgeEsm } from "../../components/Badge"
import { Button, ButtonLoader } from "../../components/Button"
import { getType } from "../ESMScreen"
import EsmPDFDocument, { EsmPDFDocumentOCT } from "../../components/ESMPdf"
import HeatmapSolos, { getLegend, getLegendPresent } from "../../components/HeatmapSolos"
import { Spinner } from "../../components/Loading"
import { useReactToPrint } from "react-to-print"
import { uuidv4 } from "@firebase/util"
import { EsmScaleChartLabel } from "../../components/EscaleBar"
import "./styles.scss"
import ESMReportNew from "../../components/ESMPdf/ESMReportNew"
// Removendo dependências problemáticas

export const getIsGenericCategory = (category) => ["Identificação"].includes(category)

const ModalConcept = ({ modalIsOpen, setModalIsOpen, columnsConcept, data, scaleIndicator }) => {
  const indicatorVariables = isJson(scaleIndicator?.variables)
    ? JSON.parse(scaleIndicator?.variables)
    : scaleIndicator?.variables

  const finalData =
    Array.isArray(indicatorVariables) && indicatorVariables.map((variable) => ({ variable }))

  return (
    <ModalPanel modalIsOpen={modalIsOpen} width={"100%"}>
      <ModalHeader closeModal={() => setModalIsOpen(false)} title="Conceito" />
      <ModalBody className="grid-table-concept">
        <Grid columns={columnsConcept} rows={Array.isArray(finalData) ? finalData : []} />
      </ModalBody>
    </ModalPanel>
  )
}

export const ModalGeneratePDF = ({
  modalIsOpenGeneratePDF,
  closeModal,
  esmData = {},
  actionPlan = [],
  dataValeToExport = [],
  esmId,
  appended,
  barometerData = [],
  projectId,
  categories = [],
  data = [],
  esm = {},
}) => {
  const esmIdFilter = "7ea1de77-706a-413f-a9da-cb6f82febcbc"
  const componentRef = useRef();
  const [loading, setLoading] = useState(false);
  const [isReportReady, setIsReportReady] = useState(false);
  
  // Renderizar o relatório após o modal abrir
  useEffect(() => {
    if (modalIsOpenGeneratePDF) {
      // Pequeno delay para mostrar o loading antes de renderizar
      const timer = setTimeout(() => {
        setIsReportReady(true);
      }, 100);
      
      return () => clearTimeout(timer);
    } else {
      setIsReportReady(false);
    }
  }, [modalIsOpenGeneratePDF]);
  
  // Função para download direto do PDF usando iframe
  const handleGeneratePDF = () => {
    setLoading(true);
    
    try {
      // Criar um iframe invisível para impressão
      const iframe = document.createElement('iframe');
      iframe.style.position = 'absolute';
      iframe.style.top = '-9999px';
      document.body.appendChild(iframe);
      
      // Escrever conteúdo no iframe
      const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
      iframeDoc.open();
      iframeDoc.write(`
        <!DOCTYPE html>
        <html>
          <head>
            <title>ESM_Report_${new Date().toISOString().split('T')[0]}</title>
            <style>
              @media print {
                @page {
                  size: A4;
                  margin: 10mm;
                }
                body {
                  font-family: Arial, sans-serif;
                  color: #333;
                  background-color: white;
                  -webkit-print-color-adjust: exact !important;
                  print-color-adjust: exact !important;
                }
                /* Estilos de cores simples */
                .alto { background-color: #327448 !important; color: white !important; }
                .bom { background-color: #47a67c !important; color: white !important; }
                .medio { background-color: #ffcd37 !important; color: black !important; }
                .baixo { background-color: #f78c2c !important; color: black !important; }
                .ruim { background-color: #f14423 !important; color: white !important; }
              }
            </style>
          </head>
          <body>
            ${componentRef.current.outerHTML}
          </body>
        </html>
      `);
      iframeDoc.close();
      
      // Esperar o iframe carregar
      setTimeout(() => {
        try {
          // Imprimir o iframe
          iframe.contentWindow.focus();
          iframe.contentWindow.print();
          
          // Remover o iframe após a impressão
          setTimeout(() => {
            document.body.removeChild(iframe);
            setLoading(false);
          }, 1000);
        } catch (printError) {
          console.error('Erro ao imprimir:', printError);
          document.body.removeChild(iframe);
          setLoading(false);
          alert('Erro ao imprimir. Por favor, tente novamente.');
        }
      }, 1000);
    } catch (error) {
      console.error('Erro ao preparar impressão:', error);
      setLoading(false);
      alert('Ocorreu um erro ao preparar a impressão. Por favor, tente novamente.');
    }
  };

  const HeaderWithButtons = () => (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
      <h3 className="modal-title">
        {esmId === esmIdFilter ? "Aplicações da propriedade" : "Gerar Relatório ESM"}
      </h3>
      <div style={{ display: "flex", gap: "10px" }}>
        <ButtonLoader
          loading={loading}
          handleClick={handleGeneratePDF}
          label="Baixar PDF"
          messageProcess={"Gerando PDF, aguarde..."}
        />
      </div>
    </div>
  );

  return (
    <ModalPanel modalIsOpen={modalIsOpenGeneratePDF} width={1000}>
      <ModalHeader closeModal={closeModal}>
        <HeaderWithButtons />
      </ModalHeader>
      <ModalBody className="esm-pdf-viewer-container">
        {!isReportReady ? (
          <div style={{ 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center', 
            minHeight: '400px',
            flexDirection: 'column',
            gap: '20px'
          }}>
            <Spinner size="large" />
            <p style={{ color: '#666', fontSize: '16px' }}>Carregando relatório...</p>
          </div>
        ) : (
          <div ref={componentRef} style={{ padding: "20px" }}>
            <ESMReportNew
              esm={esm}
              esmData={esmData}
              barometerData={barometerData}
              categories={categories}
              data={data}
              forPrint={true}
            />
          </div>
        )}
      </ModalBody>
    </ModalPanel>
  )
}

const BadgeEsmAction = ({ value, props, data, esmId }) => {
  return (
    <BadgeEsm
      label={value}
      type={getType(value)}
      handleClick={() => props?.openModalConcept(data)}
      esmId={esmId}
    />
  )
}

const VariablesCell = ({ props, data }) => {
  let dataToShow = ""

  let formattedVariables = isJson(data?.variables)
    ? JSON.parse(data?.variables)
    : data?.variables !== null
    ? data?.variables
    : {}

  if (props?.isCommunitySide) {
    dataToShow = formattedVariables
  } else if (formattedVariables) {
    dataToShow = Object.keys(formattedVariables)
      .filter((row) => formattedVariables[row])
      .map((row) => `${row}: ${formattedVariables[row]}`)
  }

  return (
    <div className="sub-list__container">
      {Array.isArray(dataToShow) &&
        dataToShow?.reverse().map((row) => (
          <div className="list-item">
            <small style={{ display: "flex", flexDirection: "column", margin: "4px 0px" }}>
              {!row.split(":")[0].includes("METODO") ? (
                <span>
                  {row.split(":")[0].includes("UNIDADE") ? (
                    <>
                      <strong>UNIDADE:</strong> {row.split(":")[1] || ""}
                    </>
                  ) : (
                    <>
                      <strong>Valor:</strong>{" "}
                      {(row.split(":")[1] !== null && row.split(":")[1]) || ""}
                    </>
                  )}
                </span>
              ) : (
                <span>
                  <strong>Método:</strong> {row.split(":")[1]}
                </span>
              )}
            </small>
          </div>
        ))}
    </div>
  )
}

const indexConceptColumn = (props) =>
  props.esmId !== "7ea1de77-706a-413f-a9da-cb6f82febcbc"
    ? [
        {
          id: 5,
          field: "value",
          label: "Indice",
          width: "100px",
          cellRenderer: ({ value, data }) =>
            getIsGenericCategory(data.category) ? (
              <></>
            ) : (
              <div style={{ paddingLeft: "20px" }}>
                {parseFloat(isNaN(value) ? 0 : value).toFixed(2)}
              </div>
            ),
        },
      ]
    : []

const variablesColumn = (props) =>
  !props.isCommunitySide
    ? [
        {
          id: 2,
          field: "variables",
          label: "Valores dos Critérios",
          width: "200px",
          cellRenderer: ({ value, data }) => <VariablesCell {...{ value, props, data }} />,
        },
      ]
    : []

const columnsConcept = [
  {
    id: 0,
    label: "Variaveis",
    field: "variable",
    width: "100%",
  },
]

const sortByIdentification = (data) => {
  return data.sort((a, b) => {
    const aIsIdent = a.category === "Identificação" ? 0 : 1
    const bIsIdent = b.category === "Identificação" ? 0 : 1
    return aIsIdent - bIsIdent
  })
}

const columnsProducers = (props) => [
  {
    id: 1,
    field: "title",
    label: "Nome",
    width: "544px",
    cellRenderer: ({ value }) => {
      const getLabel = (label) => {
        if (label === "IQS_tax") return "Diversidade Taxonômica"
        else if (label === "GF_total") return "Gêneros Funcionais"
        else if (label === "IQS_Ec") return "Perfil Bioquímico"
        else return label
      }

      return <div className="rgt-cell-inner">{getLabel(value)}</div>
    },
  },
  {
    id: 3,
    field: "category",
    label: "Etapa",
    cellRenderer: ({ value, data }) => {
      return <span>{getIsGenericCategory(data.category) ? <b>{value}</b> : value}</span>
    },
  },
  {
    id: 4,
    field: "conceito",
    label: "Conceito",
    width: "140px",
    cellRenderer: ({ value, data }) => {
      return (
        <div className="rgt-cell-inner rgt-text-truncate">
          {getIsGenericCategory(data.category) ? (
            <></>
          ) : (
            <BadgeEsmAction {...{ value, props, data, esmId: props.esmId }} />
          )}
        </div>
      )
    },
  },
  ...variablesColumn(props),
  ...indexConceptColumn(props),
  // {
  //   id: 6,
  //   field: "recommend",
  //   label: "",
  //   cellRenderer: ({ data }) => (
  //     <div style={{ justifyContent: "center", padding: "10px" }}>
  //       <ButtonRouter
  //         label="Recomendação"
  //         variant="outline"
  //         to="/esm/producer/plan/community"
  //         state={{ ...data, esmId: props?.esmId, userId: props?.userId }}
  //       />
  //     </div>
  //   ),
  // },
]

const ESMDetailsScreen = ({
  data,
  esmData,
  filter,
  setFilter,
  goBack,
  esmUser,
  esm,
  esmId,
  userId,
  scaleIndicator,
  setScaleIndicator,
  dataToExport,
  dataValeToExport,
  modalIsOpenGeneratePDF,
  setModalIsOpenGeneratePDF,
  categories,
  isCommunitySide,
  heatmapData,
  scope,
  actionPlan,
  loadingActionPlan,
  handleOpenGenerateEsm,
  handleCloseGenerateEsm,
  barometerData,
}) => {
  const funcionais = useRef(null)
  const componentRef = React.useRef(null)
  const onBeforeGetContentResolve = React.useRef(null)
  const [loading, setLoading] = React.useState(false)

  const [modalIsOpen, setModalIsOpen] = useState(false)
  // const ambiental = esm?.summary["Ambiental"] ? esm?.summary["Ambiental"] : 0
  // const economico = esm?.summary["Econômico"] ? esm?.summary["Econômico"] : 0
  // const social = esm?.summary["Social"] ? esm?.summary["Social"] : 0
  const geral = esm?.details["Geral"]
    ? esm?.details["Geral"]
    : categories.find(({ category }) => category === "GeneralMean")?.mean ?? 0

  const openModalConcept = (scaleIndicator) => {
    setModalIsOpen(true)
    setScaleIndicator(scaleIndicator)
  }

  const handleAfterPrint = React.useCallback(() => {}, [])

  const handleOnBeforeGetContent = React.useCallback(() => {
    setLoading(true)
    return new Promise((resolve) => {
      setTimeout(() => {
        setLoading(false)
        resolve()
      }, 2000)
    })
  }, [setLoading])

  const reactToPrintContent = React.useCallback(() => {
    return componentRef.current
  }, [componentRef.current])

  const handlePrint = useReactToPrint({
    content: reactToPrintContent,
    documentTitle: uuidv4(),
    onBeforeGetContent: handleOnBeforeGetContent,
    onAfterPrint: handleAfterPrint,
    copyStyles: true,
    removeAfterPrint: true,
    pageStyle: `
      @page {
        size: auto;
        margin: 10mm;
      }
      @media print {
        body {
          -webkit-print-color-adjust: exact !important;
          print-color-adjust: exact !important;
          color-adjust: exact !important;
        }
      }
    `
  })

  React.useEffect(() => {
    if (typeof onBeforeGetContentResolve.current === "function") {
      onBeforeGetContentResolve.current()
    }
  }, [onBeforeGetContentResolve.current])

  const ButtonPrint = () => {
    return (
      <div
        style={{
          display: "flex",
          width: "100%",
          justifyContent: "flex-end",
          marginTop: 20,
          padding: "0 32px",
        }}>
        <ButtonLoader
          loading={loading}
          handleClick={handlePrint}
          label="Imprimir Gráficos"
          messageProcess={"Gerando PDF, aguarde...."}
        />
      </div>
    )
  }

  const LegendChart = ({ item }) => {
    return (
      <div className="title-legend">
        <h4>{item.title}</h4>
        {["Fungos", "Bactérias"].includes(item.title) ? getLegend() : getLegendPresent()}
      </div>
    )
  }

  const isVale = esmId === "7ea1de77-706a-413f-a9da-cb6f82febcbc"

  return (
    <>
      <Card className={`no-border ${!isVale ? "esm-card" : "vale-esm-card"}`}>
        <HeaderCardESM
          title={isVale ? "IQS do Empreendimento" : esmUser ? "ESM Produtor" : "ESM Comunidade"}
          {...{ goBack }}>
          {dataToExport && Object?.values(dataToExport)?.length > 0 && (
            <>
              {isVale ? (
                <Button
                  label="Clique aqui para saber as aplicações na sua propriedade"
                  variant="outline"
                  handleClick={handleOpenGenerateEsm}
                />
              ) : (
                <ButtonLoader
                  label="Gerar Relatório Esm"
                  variant="ghost"
                  handleClick={handleOpenGenerateEsm}
                  classButton={"historico"}
                  isDisabled={!barometerData?.length}
                  loading={loadingActionPlan}
                  messageProcess="Gerando pdf..."
                />
              )}
            </>
          )}
        </HeaderCardESM>
        <section className="esm-producer-content">
          <EsmSpeedometerProducer
            {...{
              filter,
              setFilter,
              esmUser,
              esmId,
            }}
            categories={categories.filter((c) => c.category !== "Identificação")}
            scaleTitle={`Nota: ${parseFloat(geral || 0).toFixed(1)}`}
            scaleValue={geral}
          />
          <div className="esm-all-producers-table">
            <Grid
              columns={columnsProducers({ esmId, userId, openModalConcept, isCommunitySide })}
              rows={sortByIdentification(data).filter(
                (item) => !filter || item.Dimensao === filter || item.category === filter,
              )}
            />
          </div>
        </section>
        {isVale && !esmUser && (
          <section>
            {heatmapData && heatmapData.length > 0 ? (
              <>
                <ButtonPrint />
                <div ref={componentRef}>
                  <HeaderCardESM title={"Gêneros funcionais"} />
                  <div className="horizontal-possible " ref={funcionais}>
                    {heatmapData &&
                      ["Bactérias", "Fungos"].map((key) => {
                        const item = heatmapData?.find((item) => item.title === key)

                        return (
                          item && (
                            <div style={{ width: "100%", margin: "0 auto" }}>
                              <LegendChart {...{ item }} />
                              <EsmScaleChartLabel
                                data={item}
                                title={`Quantidade (${key})`}
                                valuesToVerify={[
                                  { label: "1. Não patógeno", value: 100 },
                                  { label: "2. Não patógeno", value: 80 },
                                  { label: "3. Não patógeno", value: 50 },
                                  { label: "4. Patógeno", value: -1 },
                                  { label: "5. Ausência", value: 0 },
                                ]}
                              />
                              <HeatmapSolos {...item} />
                            </div>
                          )
                        )
                      })}
                  </div>
                  <HeaderCardESM title={"Fixação do carbono"}></HeaderCardESM>
                  {heatmapData &&
                    ["Carbono"].map((key) => {
                      const item = heatmapData?.find((item) => item.title === key)

                      return (
                        item && (
                          <div style={{ width: "100%", margin: "0 auto" }}>
                            <LegendChart {...{ item }} />
                            <EsmScaleChartLabel
                              data={item}
                              title={`Quantidade de Presença e Ausência de ${key}`}
                              valuesToVerify={[
                                { label: "Presença", value: 100 },
                                { label: "Ausência", value: 0 },
                              ]}
                            />
                            <HeatmapSolos {...item} />
                            <div className="pagebreak" />
                          </div>
                        )
                      )
                    })}
                  <HeaderCardESM title={"Proteínas do ciclo do N, P e S"}></HeaderCardESM>
                  <div className="horizontal-possible ">
                    {heatmapData &&
                      ["Nitrogênio", "Fósforo", "Enxofre"].map((key) => {
                        const item = heatmapData?.find((item) => item.title === key)

                        return (
                          item && (
                            <div style={{ width: "100%", margin: "0 auto" }}>
                              <LegendChart {...{ item }} />
                              <EsmScaleChartLabel
                                data={item}
                                title={`Quantidade de Presença e Ausência de ${key}`}
                                valuesToVerify={[
                                  { label: "Presença", value: 100 },
                                  { label: "Ausência", value: 0 },
                                ]}
                              />
                              <HeatmapSolos {...item} />
                            </div>
                          )
                        )
                      })}
                  </div>
                </div>
              </>
            ) : (
              <div className="horizontal-possible ">
                <Spinner color="#188683" />
              </div>
            )}
          </section>
        )}
      </Card>
      <ModalConcept {...{ modalIsOpen, setModalIsOpen, columnsConcept, data, scaleIndicator }} />
      <ModalGeneratePDF
        {...{
          modalIsOpenGeneratePDF,
          setModalIsOpenGeneratePDF,
          closeModal: handleCloseGenerateEsm,
          esmId,
          projectId: scope?.id,
          esmData: dataToExport,
          dataValeToExport,
          barometerData,
          actionPlan,
          categories,
          data,
          esm,
        }}
      />
    </>
  )
}

export default ESMDetailsScreen
